const config = {
  apiurl: 'https://ittrainingonline.co.in/laravelapi/'
};

export default config;